import qs from 'qs';
import {deleteAccess, deleteRefresh, getAccess} from './api/auth';

export const {NODE_ENV} = process.env;

const isDev = NODE_ENV === 'development';
const isStaging = NODE_ENV === 'staging';

let hashChangeCallback = () => {
    // this should never fire, because it needs to be updated with a store function
    debugger;
};

export const setHashChangeCallback = (callback) => {
    // console.log('setHashChangeCallback()');
    hashChangeCallback = callback;
    setHashListener();
};

export const setHashListener = (delay = false) => {
    // console.log('setHashListener')
    setTimeout(
        () => {
            window.addEventListener('hashchange', hashChangeCallback, false);
        },
        delay ? 250 : 0,
    );
};


export const removeHashListener = () => {
    // console.log('removeHashListener')
    window.removeEventListener('hashchange', hashChangeCallback);
};

export const logout = (wipeStorage = true) => {

    if (wipeStorage) {
        localStorage.clear();
    } else {
        deleteAccess();
        deleteRefresh();
    }
    if (window.location.pathname !== '/login') {
        window.location.href = '/login';
    }
};

export const slugify = (string) => {
    const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœøṕŕßśșțùúüûǘẃẍÿź·/_,:;';
    const b = 'aaaaaaaaceeeeghiiiimnnnooooooprssstuuuuuwxyz------';
    const p = new RegExp(a.split('').join('|'), 'g');

    return string.toString().toLowerCase()
        .replace(/\s+/g, '-')
        .replace(p, c => b.charAt(a.indexOf(c)))
        .replace(/&/g, '-and-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
};

export const handleCallback = (callback) => {
    if (callback && typeof callback === 'function') {
        // hack for cannot dispatch in the middle of a dispatch
        setTimeout(() => {
            try {
                callback();
            } catch (error) {
                console.log(error);
                console.trace();
            }
        }, 25);
    }
};

export const getUser = () => {
    try {
        return JSON.parse(atob(getAccess().token.split('.')[1]));
    } catch (error) {
        logout(false);
    }
};

export const getPrice = (pennies = 0) => {
    let dollars = pennies / 100;
    return `$${dollars.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
};

export const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
};

export const buildHtmlText = (text) => {
    if (!text || typeof text !== 'string') {
        return '';
    }

    return text.split('\n').join('\n<br/>');
};

export const parseSearch = () => {
    let search = {};
    let array = window.location.search.split('?');
    if (array.length === 2) {
        search = qs.parse(array[1]);
    }
    return search;
};

export const detectNative = () => {
    localStorage.setItem('native', parseSearch()['native']);
};

export const isNative = () => {
    return localStorage.getItem('native') === 'true' || null;
};

export const logger = {
    trace: (...x) => {
        if (isDev) {
            console.log('[TRACE]', new Date().getTime(), ...x);
            console.trace();
        }
    },
    silly: (...x) => {
        if (isDev) {
            console.log('[SILLY]', new Date().getTime(), ...x);
        }
    },
    debug: (...x) => {
        if (isDev || isStaging) {
            console.log('[DEBUG]', new Date().getTime(), ...x);
        }
    },
    info: (...x) => {
        if (isDev || isStaging) {
            console.log('[INFO]', new Date().getTime(), ...x);
        }
    },
    error: (...x) => {
        console.log('[ERROR]', new Date().getTime(), ...x);
    },
    fatal: (...x) => {
        console.log('[FATAL]', new Date().getTime(), ...x);
    }
};


export const getAdjustedPrice = (offering, client, company) => {
    const account = client.account;
    const accounts = company && company.settings && company.settings.json_data && company.settings.json_data.accounts;
    if (offering.json_data && offering.json_data.commissions && offering.json_data.commissions[account] && accounts && accounts[account]) {
        const price = offering.json_data.commissions[account].price || offering.json_data.commissions[account].value;
        console.log({price})
        return price === 0 ? price : (price || offering.price);
    }
    return offering.price;
};


window.utilities = {
    getUser
};